// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3641":"739bffaef238dd71","9721":"ec7b7789e112e0a9"}[chunkId] + ".css";
};